<template>
  <meta-overlay v-model="isVisible" append-to-body close-by-mark transition="tra-scaleIn">
    <div class="account-bg" @click.stop>
      <div class="title">【完善账号】</div>
      <div class="content">为防止账号信息丢失，请您完善账号后再进行充值。</div>
      <div class="footer">
        <div class="confirm" @click="confirm">确定</div>
        <div class="close" @click="closeImprove">取消</div>
      </div>
    </div>
  </meta-overlay>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { jsb } from "~/utils/jsb";

const isVisible = ref<boolean>(false);

/**
 * @description 去完善账号
 * @return {void}
 */
const confirm = (): void => {
  if (jsb?.clientType === false) return;
  jsb?.execAsyncDataV2("goAccountSetting");
  closeImprove();
};

/**
 * @description 关闭弹窗
 * @return {void}
 */
const closeImprove = (): void => {
  isVisible.value = false;
};

/**
 * @description 打开弹窗
 * @return {void}
 */
const open = (): void => {
  isVisible.value = true;
};

/**
 * @description 关闭弹窗
 * @return {void}
 */
const close = (): void => {
  isVisible.value = false;
};

defineExpose({
  open,
  close
});
</script>
<style scoped lang="scss">
.account-bg {
  width: 13.25rem;
  background: #fff;
  position: relative;
  border-radius: 0.5rem;

  .title {
    padding-top: 0.87rem;
    text-align: center;
    font-size: 0.69rem;
    font-weight: bold;
  }

  .content {
    color: #888;
    font-size: 0.58rem;
    padding: 0.65rem;
    text-align: center;
  }

  .footer {
    font-size: 0.7rem;
    border-top: 1px solid #e9e8e8;
    display: flex;

    .confirm {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      color: #ff7210;
      border-right: 1px solid #e9e8e8;
      text-align: center;
    }

    .close {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      color: #666;
      border-left: 1px solid #e9e8e8;
      text-align: center;
    }
  }
}
</style>
